import Box from "@mui/material/Box"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { CheckCircleFilledRounded } from "@mui-symbols-material/w300"
import type { FC, ReactNode } from "react"

interface TabletSuccessDialogProps {
  title: string | ReactNode
  agrNumber?: string
  children?: ReactNode
  actions?: ReactNode
  onClose: () => void
}

export const TabletSuccessDialog: FC<TabletSuccessDialogProps> = ({ title, agrNumber, children, actions, onClose }) => {
  return (
    <Dialog
      open
      onClose={onClose}
      fullScreen
      data-testid='tablet-success-dialog'
      PaperProps={{
        className: "flex flex-col bg-gray-100 gap-6 p-6",
      }}
    >
      <DialogContent className='flex flex-1 flex-col items-center justify-center gap-6 py-6'>
        <CheckCircleFilledRounded className='text-tertiary-green-500' style={{ height: 158, width: 158 }} />

        <Typography variant='h5' color='primary' className='text-center text-[48px] font-bold text-gray-900'>
          {title}
        </Typography>

        <Box className='flex flex-col items-center gap-6 bg-white p-6'>
          {agrNumber && (
            <Box className='flex flex-col items-center'>
              <Typography variant='subtitle1' color='primary' className='text-gray-700'>
                Goods Receipt #
              </Typography>
              <Typography variant='h5' color='primary' className='font-bold text-gray-900'>
                {agrNumber}
              </Typography>
            </Box>
          )}

          {children && <Box className='flex w-[510px] flex-col items-center bg-white'>{children}</Box>}
        </Box>
      </DialogContent>

      {actions && <Box className='flex w-full flex-col gap-3'>{actions}</Box>}
    </Dialog>
  )
}
